var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateDonation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 416 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_665:4416)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.869,
    cy: 187.08,
    rx: 159.869,
    ry: 44.2191,
    fill: "#C4C4C4",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.433 70.7646L305.291 75.0712C305.523 75.0765 305.74 75.1891 305.878 75.3762L340.625 122.555C340.99 123.05 340.637 123.75 340.022 123.75H75.6004C74.969 123.75 74.6202 123.017 75.0183 122.527L116.834 71.0416C116.98 70.8615 117.201 70.7593 117.433 70.7646Z",
    fill: "#908787",
    stroke: "#B7AFAF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3312,
    y: 27.4614,
    width: 219.076,
    height: 149.165,
    rx: 1.75,
    fill: "white",
    stroke: "#918787",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.95,
    y1: 94.9907,
    x2: 305.788,
    y2: 94.9907,
    stroke: "#918787",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.95,
    y1: 108.697,
    x2: 258.312,
    y2: 108.697,
    stroke: "#918787",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.95,
    y1: 122.302,
    x2: 222.705,
    y2: 122.302,
    stroke: "#918787",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.95,
    y1: 135.908,
    x2: 222.705,
    y2: 135.908,
    stroke: "#918787",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_665:4416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.549 105.369C295.008 102.887 291.23 103.334 288.897 106.092L287.984 107.171L287.071 106.092C284.743 103.334 280.96 102.887 278.419 105.369C275.508 108.218 275.355 113.331 277.96 116.419L286.932 127.038C287.511 127.723 288.452 127.723 289.032 127.038L298.003 116.419C300.613 113.331 300.46 108.218 297.549 105.369V105.369Z",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.145 123.453V209.891C341.145 210.305 340.809 210.641 340.395 210.641H75.3433C74.9291 210.641 74.5933 210.305 74.5933 209.891V123.453C74.5933 123.038 74.9291 122.703 75.3433 122.703H147.524C147.938 122.703 148.274 123.038 148.274 123.453V140.678C148.274 141.369 148.834 141.928 149.524 141.928H266.214C266.904 141.928 267.464 141.369 267.464 140.678V123.453C267.464 123.038 267.799 122.703 268.214 122.703H340.395C340.809 122.703 341.145 123.038 341.145 123.453Z",
    fill: "white",
    stroke: "#B7AFAF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.079 71.5425L206.103 64.6921L200.447 71.1761L198.497 68.9415L204.154 62.4574L198.689 56.1932L200.702 53.8853L206.167 60.1496L211.631 53.8853L213.581 56.1199L208.116 62.3842L214.092 69.2346L212.079 71.5425Z",
    fill: "#908787"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_665:4416",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.584 54.4235C399.248 54.4235 416 42.2404 416 27.2117C416 12.1831 399.248 0 378.584 0C357.919 0 341.168 12.1831 341.168 27.2117C341.168 30.9327 342.195 34.4792 344.054 37.7096L333.957 51.3717C333.438 52.0743 334.006 53.0581 334.874 52.9597L358.687 50.2614C364.45 52.8982 371.272 54.4235 378.584 54.4235Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.584 54.4235C399.248 54.4235 416 42.2404 416 27.2117C416 12.1831 399.248 0 378.584 0C357.919 0 341.168 12.1831 341.168 27.2117C341.168 30.9327 342.195 34.4792 344.054 37.7096L333.957 51.3717C333.438 52.0743 334.006 53.0581 334.874 52.9597L358.687 50.2614C364.45 52.8982 371.272 54.4235 378.584 54.4235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.054 37.7096L344.456 38.0068L344.65 37.7437L344.487 37.4602L344.054 37.7096ZM333.957 51.3717L333.555 51.0746L333.555 51.0746L333.957 51.3717ZM334.874 52.9597L334.818 52.4629L334.818 52.4629L334.874 52.9597ZM358.687 50.2614L358.895 49.8067L358.769 49.749L358.631 49.7646L358.687 50.2614ZM415.5 27.2117C415.5 34.5267 411.424 41.1928 404.747 46.049C398.07 50.9047 388.822 53.9235 378.584 53.9235V54.9235C389.01 54.9235 398.47 51.8506 405.335 46.8577C412.2 41.8651 416.5 34.9254 416.5 27.2117H415.5ZM378.584 0.5C388.822 0.5 398.07 3.51872 404.747 8.3745C411.424 13.2306 415.5 19.8968 415.5 27.2117H416.5C416.5 19.498 412.2 12.5583 405.335 7.56576C398.47 2.57283 389.01 -0.5 378.584 -0.5V0.5ZM341.668 27.2117C341.668 19.8968 345.743 13.2306 352.421 8.3745C359.097 3.51872 368.346 0.5 378.584 0.5V-0.5C368.157 -0.5 358.698 2.57283 351.832 7.56576C344.968 12.5583 340.668 19.498 340.668 27.2117H341.668ZM344.487 37.4602C342.668 34.2992 341.668 30.838 341.668 27.2117H340.668C340.668 31.0274 341.721 34.6592 343.62 37.959L344.487 37.4602ZM334.359 51.6689L344.456 38.0068L343.651 37.4124L333.555 51.0746L334.359 51.6689ZM334.818 52.4629C334.384 52.5121 334.1 52.0202 334.359 51.6689L333.555 51.0746C332.776 52.1284 333.628 53.6041 334.93 53.4565L334.818 52.4629ZM358.631 49.7646L334.818 52.4629L334.93 53.4565L358.744 50.7582L358.631 49.7646ZM378.584 53.9235C371.341 53.9235 364.59 52.4124 358.895 49.8067L358.479 50.7161C364.311 53.3841 371.204 54.9235 378.584 54.9235V53.9235Z",
    fill: "#918787",
    mask: "url(#path-11-inside-1_665:4416)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_665:4416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.475 13.606C374.233 13.606 371.485 15.3441 369.328 18.4438C368.936 19.0061 369.057 19.7771 369.603 20.191L371.896 21.9294C372.447 22.3474 373.231 22.2497 373.663 21.7089C374.994 20.0411 375.982 19.0808 378.061 19.0808C379.696 19.0808 381.719 20.1331 381.719 21.7186C381.719 22.9172 380.729 23.5328 379.115 24.4379C377.232 25.4934 374.741 26.807 374.741 30.0931V30.6133C374.741 31.3178 375.312 31.8888 376.016 31.8888H379.868C380.572 31.8888 381.144 31.3178 381.144 30.6133V30.3065C381.144 28.0285 387.801 27.9337 387.801 21.7695C387.801 17.1273 382.986 13.606 378.475 13.606ZM377.942 33.4545C375.912 33.4545 374.261 35.1061 374.261 37.1361C374.261 39.1661 375.912 40.8177 377.942 40.8177C379.972 40.8177 381.624 39.1661 381.624 37.1361C381.624 35.106 379.972 33.4545 377.942 33.4545Z",
    fill: "#908787"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_665:4416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 416,
    height: 231,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_665:4416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7379,
    height: 27.2117,
    fill: "white",
    transform: "translate(276.115 102.043)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_665:4416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4088,
    height: 27.2117,
    fill: "white",
    transform: "translate(367.738 13.606)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateDonation);
export default __webpack_public_path__ + "static/media/empty-state-donation.505f2ceb.svg";
export { ForwardRef as ReactComponent };